/* Sora & Soil motion system (ss-reveal.js)
   Doctrine per round 4 Design Notes §3: scroll-settle reveals
   (rise, 0.9s, once, staggered up to 270ms) and one living still
   per page. Document-register pages ship without reveal hooks.
   Respects prefers-reduced-motion and the theme motion setting
   (body carries ss-motion / ss-motion-off from theme.liquid). */

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = document.body.classList.contains('ss-motion') && !reduced;

  var nodes = document.querySelectorAll('.ss-reveal');
  if (!nodes.length) return;

  if (!enabled || !('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var group = el.closest('[data-ss-reveal-group]') || document;
      var siblings = Array.prototype.slice.call(group.querySelectorAll('.ss-reveal'));
      var index = siblings.indexOf(el);
      var delay = Math.min(index > 0 ? index * 90 : 0, 270);
      el.style.setProperty('--ss-reveal-delay', delay + 'ms');
      el.classList.add('is-revealed');
      observer.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  nodes.forEach(function (n) { observer.observe(n); });
})();

/* 検 record toggles: small disclosure cards for verification records. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-record-toggle]');
    if (!btn) return;
    var card = document.getElementById(btn.getAttribute('aria-controls'));
    if (!card) return;
    var open = card.hasAttribute('hidden');
    if (open) { card.removeAttribute('hidden'); } else { card.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
